// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__RuV6q","socialButtons":"Login_socialButtons__3AbCr","icon":"Login_icon__jyMoq"};